/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchOperator = {
    Equals: 'Equals',
    NotEquals: 'NotEquals',
    Contains: 'Contains',
    StartsWith: 'StartsWith',
    EndsWith: 'EndsWith',
    GreaterThan: 'GreaterThan',
    LessThan: 'LessThan',
    GreaterThanOrEqual: 'GreaterThanOrEqual',
    LessThanOrEqual: 'LessThanOrEqual',
    In: 'In'
} as const;
export type SearchOperator = typeof SearchOperator[keyof typeof SearchOperator];


export function instanceOfSearchOperator(value: any): boolean {
    for (const key in SearchOperator) {
        if (Object.prototype.hasOwnProperty.call(SearchOperator, key)) {
            if (SearchOperator[key as keyof typeof SearchOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchOperatorFromJSON(json: any): SearchOperator {
    return SearchOperatorFromJSONTyped(json, false);
}

export function SearchOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchOperator {
    return json as SearchOperator;
}

export function SearchOperatorToJSON(value?: SearchOperator | null): any {
    return value as any;
}

export function SearchOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): SearchOperator {
    return value as SearchOperator;
}

